import React from 'react';

interface ErrorMessageProps {
    error: any;
    color?: 'red' | 'blue' | 'green' | 'yellow';
    size?: 'sm' | 'md' | 'lg';
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, color = 'red', size = 'sm' }) => {
    const message = error?.message || error;
    if (!message || typeof message !== 'string') return null;

    return <div className={`text-${color}-600 text-${size}`}>{message}</div>;
};

export default ErrorMessage;
